import React, { useEffect, forwardRef } from 'react'
import { XDivider, FlexByRow } from 'irmlib/styles'
import styled from 'styled-components'
// import { useHistory } from 'react-router-dom'
import { ContainedButton, OutlinedButton } from 'irmlib/components/Controls'
// import * as routePaths from '../../../../navigation/routePaths'
import * as gdeTrancactions from '../../../../services/firestore/gdeTransactions'
// import * as gdeTransactionsLite from '../../../../services/firestore/gdeTransactionsLite'
import { closeGeneralDialog, openGeneralDialog } from '../../../../irmlib/src/containers'
import { userRoleAdmin, userRoleSuperUser } from '../../../../common/constants'
import UserRolePermission from '../../../Controls/UserRolePermission'
import * as constants from 'irmlib/common/constants'
import { successToast } from '../../../../common/functions'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

// const functions = getFunctions()

const ButtonsContainer = styled(FlexByRow)`
  justify-content: flex-end;
  padding-top: 1%;
`

const TopButtons = forwardRef((props, ref) => {
  const [disabledReTransmit, setdisabledReTransmit] = React.useState(true)
  
  const { t } = useTranslation()
  const selectedRow = props.selectedData


  useEffect(() => {
    if (isEmpty(selectedRow)) {
      onSelectionChange(selectedRow)
    } else {
      setdisabledReTransmit(true)
    }
  }, [props.selectedData])

  const isEmpty = (obj) => {
    return Object.values(obj).length
  }
  
  const onSelectionChange = async (rows) => {
    // this code is written for retransmission
    if (rows?.status1 === constants.jobStatus.transmitted) {
      setdisabledReTransmit(false)
    } else {
      setdisabledReTransmit(true)
    }
  }
  
  const ButtonsForRetransmitDialogBox = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleRetransmitButtonOnClick} >buttons.yes</ContainedButton>
    </>
    
  const handleRetransmitButtonOnClick = async () => {
    const data = {
      actionTs: new Date(),
      boxesCompleted: 0,
      jobLevelRetransmit: true,
      jobStatus: constants.jobStatus.readyToTransmit,
      autoTransmit: 'true',
      autoTransmitAndStatus: `true-${constants.jobStatus.readyToTransmit}`,
    }

    const retransmitMetricData = {
      activityType: constants.retransmitAction,
      jobId: selectedRow.jobId,
    }

    await gdeTrancactions.updateJob(selectedRow.jobId, data)
  
    const boxesRaw = await gdeTrancactions.getBoxesForJob(selectedRow.jobId)
    boxesRaw.forEach(async(ele) => {
      const box = ele.data()
      await gdeTrancactions.updateBoxData(selectedRow.jobId, box.boxId, 
        { 
          actionTs: new Date(), 
          status: constants.boxStatus.approved,
          transmissionStatus: constants.boxTransmissionStatus.pending,
          transmissionStatusTs: new Date(), 
        })
    })
  
    setdisabledReTransmit(true)
    await gdeTrancactions.saveMetricsData(retransmitMetricData)
    successToast({ message: t('toast.reTransmitQueued', { jobId: selectedRow.jobId }) })
    closeGeneralDialog()
  }

  
  const handleReTransmit = () => {
    openGeneralDialog({
      title: t('messages.reTransmit'),
      noTranslateTitle: true,
      message: t('messages.reTransmitConfirmMessage'),
      translateMessage: false,
      buttons: <ButtonsForRetransmitDialogBox />,
      closeX: true
    })
  }
  
  return (
    <ButtonsContainer>
      <UserRolePermission allowsTo={[userRoleAdmin, userRoleSuperUser]}>
        <OutlinedButton disabled={disabledReTransmit} id={'allJobs_editJobs'} size='small' onClick={handleReTransmit}>
          demo.reTransmit
        </OutlinedButton>
        <XDivider width='18px' />
      </UserRolePermission>
    </ButtonsContainer>
  )
})

TopButtons.propTypes = {
  selectedData: PropTypes.object,
}

export default TopButtons